import { PELGO_HERO_VIDEO_SRC } from '@/components/pelgo-hero-background-video'
import { cn } from '@/lib/utils'
import { useState } from 'react'

const HERO_POSTER_SRC = '/assets/landing/hero-poster.webp'

export function LandingHeroVideo() {
  const [isVideoReady, setIsVideoReady] = useState(false)

  return (
    <div className="absolute inset-0 z-0">
      <img
        src={HERO_POSTER_SRC}
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover"
      />
      <video
        ref={(video) => {
          // Cached videos often skip `loadeddata` after remount (HMR), which
          // left the player at opacity-0 while it kept playing under the poster.
          if (video && video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
            setIsVideoReady(true)
          }
        }}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster={HERO_POSTER_SRC}
        onLoadedData={() => setIsVideoReady(true)}
        onCanPlay={() => setIsVideoReady(true)}
        className={cn(
          'decorative-bg-video absolute inset-0 h-full w-full object-cover transition-opacity duration-300',
          isVideoReady ? 'opacity-100' : 'opacity-0',
        )}
      >
        <source src={PELGO_HERO_VIDEO_SRC} type="video/mp4" />
        <img
          src={HERO_POSTER_SRC}
          alt="Professionals collaborating in a modern workplace"
          className="h-full w-full object-cover"
        />
      </video>
    </div>
  )
}
